import type { BlobLike } from "@pdfking/compatibility"
import type { Pixel, Rectangle } from "@pdfking/math"
import type { Sequence } from "@pdfking/tfunc"
import type { PDFReaderOptions } from "./PDFReaderOptions"

export type PDFRasterizeResult = {
  blob: BlobLike
  page: number
} & Rectangle<Pixel>

export type PDFRasterizeFunction = (
  input: PDFReaderOptions,
  image_dpi?: Pixel,
  rangeFn?: (page_count: number) => Sequence<number>
) => AsyncGenerator<PDFRasterizeResult>
